module.exports = "#footer{\r\n  width: 100%;\r\n  min-height: 50px;\r\n  left:0;\r\n  right: 0;\r\n  background: #333333;\r\n  color: #becde2;\r\n  border-top: 1px solid #444444;\r\n}\r\n#footer-content{\r\n  width: 1440px;\r\n  left:0;\r\n  right: 0;\r\n  margin: auto;\r\n  padding: 5px 10px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/footer/footer.component.css
// module id = ./src/app/components/footer/footer.component.css
// module chunks = main